import React from 'react';

import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {isMobile} from '#core/utils/context-utils.js';
import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';
import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';
import {generateRecentSearch, generateSearchResultItem} from '#core/application/modules/tiles/search/search-result.js';

import {SearchPage} from './search-page.jsx';

import PALETTE_SCHEMA from './search.palette-schema.yaml';

// NOTE: We will move this feature to tile when Mojito allow us to configure all children components inside SearchView
class SearchFeature extends AbstractVisualFeature {
    get name() {
        return 'Search';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    afterMojitoConfigBuild(mojitoConfig) {
        const RoutingView = ensureHierarchy(mojitoConfig, 'services.configurations.RoutingView');
        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push({
            path: '/search',
            element: <SearchPage />,
        });

        return super.afterMojitoConfigBuild(mojitoConfig);
    }

    getVisualConfig(PALETTE) {
        const {FONT} = PALETTE;
        if (!isMobile()) return; // For the desktop you can find styles in application header

        return {
            SearchView: {
                style: {
                    searchBox: {
                        zIndex: 2,
                    },
                    container: {
                        margin: '0 0 10px 0',
                    },
                    resultsContainer: {
                        _mobile_maxHeight: '80vh',
                        padding: '8px 0',
                    },
                },
                searchInput: generateSearchInput(PALETTE.SEARCH_INPUT),
                messageText: {
                    style: {
                        fontSize: FONT.SIZE_MEDIUM,
                        fontWeight: FONT.WEIGHT_NORMAL,
                        wordBreak: 'break-word',
                        ...PALETTE.SEARCH_RESULT.SEARCH_RECENT_ITEM_TEXT,
                    },
                },
                messageContainer: {
                    style: {
                        padding: '8px',
                    },
                },
            },
            RecentSearch: generateRecentSearch(PALETTE.SEARCH_RESULT),
            SearchResultItem: generateSearchResultItem(PALETTE.SEARCH_RESULT),
            SearchOverlay: {
                overlay: {
                    style: {
                        overlay: {
                            style: {
                                ...resolveBackground(PALETTE.SEARCH_OVERLAY_BG),
                            },
                        },
                    },
                },
                searchBackButtonIcon: icon(PALETTE.SEARCH_OVERLAY_BACK_BUTTON_ICON_COLOR),
            },
        };
    }
}

new SearchFeature(allVisuals);
